(function () {
  'use strict';

  var root = document.querySelector('[data-cookie-consent]');
  var panel = document.querySelector('[data-cookie-panel]');
  var preferences = document.querySelector('[data-cookie-preferences]');
  var status = document.querySelector('[data-cookie-status]');
  var acceptButton = document.querySelector('[data-cookie-accept]');
  var rejectButton = document.querySelector('[data-cookie-reject]');
  var customizeButton = document.querySelector('[data-cookie-customize]');
  var saveButton = document.querySelector('[data-cookie-save]');
  var reopenButton = document.querySelector('[data-cookie-reopen]');
  var choices = Array.prototype.slice.call(document.querySelectorAll('[data-cookie-choice]'));

  if (!root || !panel || !reopenButton || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  var privacyApi;
  var lastFocusedElement;

  function setPreferencesVisibility(isVisible) {
    preferences.hidden = !isVisible;
    saveButton.hidden = !isVisible;
    acceptButton.hidden = isVisible;
    rejectButton.hidden = isVisible;
    customizeButton.setAttribute('aria-expanded', String(isVisible));
    customizeButton.textContent = isVisible ? 'Back' : 'Customize';
  }

  function showBanner(openPreferences) {
    lastFocusedElement = document.activeElement;
    root.hidden = false;
    reopenButton.hidden = true;
    setPreferencesVisibility(Boolean(openPreferences));
    window.requestAnimationFrame(function () {
      panel.focus();
    });
  }

  function hideBanner() {
    root.hidden = true;
    reopenButton.hidden = false;
    status.textContent = '';
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  function syncChoices() {
    var consent = privacyApi.currentVisitorConsent();
    choices.forEach(function (choice) {
      choice.checked = consent[choice.dataset.cookieChoice] === 'yes';
    });
  }

  function saveConsent(consent) {
    status.textContent = 'Saving your choices...';
    privacyApi.setTrackingConsent(consent, function (result) {
      if (result && result.error) {
        status.textContent = 'We could not save your choices. Please try again.';
        return;
      }
      hideBanner();
    });
  }

  function optionalConsent(enabled) {
    return {
      analytics: enabled,
      marketing: enabled,
      preferences: enabled,
      sale_of_data: false
    };
  }

  acceptButton.addEventListener('click', function () {
    saveConsent(optionalConsent(true));
  });

  rejectButton.addEventListener('click', function () {
    saveConsent(optionalConsent(false));
  });

  customizeButton.addEventListener('click', function () {
    var willOpen = preferences.hidden;
    setPreferencesVisibility(willOpen);
    if (willOpen) syncChoices();
  });

  saveButton.addEventListener('click', function () {
    var consent = optionalConsent(false);
    choices.forEach(function (choice) {
      consent[choice.dataset.cookieChoice] = choice.checked;
    });
    saveConsent(consent);
  });

  reopenButton.addEventListener('click', function () {
    syncChoices();
    showBanner(true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || root.hidden || privacyApi.shouldShowBanner()) return;
    hideBanner();
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      privacyApi = window.Shopify.customerPrivacy;
      syncChoices();
      reopenButton.hidden = false;
      if (privacyApi.shouldShowBanner()) showBanner(false);
    }
  );
})();
